// extracted by mini-css-extract-plugin
export var actionButtonWrapper = "WbNiGRlV_Jg49uhiLcVj";
export var addressList = "va4gzi1iZzt0Wy0Q5C5w";
export var errorMessage = "XUYpmKkeWaObR985uf4c";
export var helpText = "pYvryYZ46AydA_baVEew";
export var nameInput = "i14SAM_OcIDL8_ThiNLs";
export var pasteButtonWrapper = "QWRvGT0TUuLTBhoxSSn_";
export var root = "TxSEqlD8hpY5nc_Gowhg";
export var warningMessage = "KCd8GY4p1vTv69FfhZdX";